import { Button, FormField, Stack } from 'canoe';
import { Field, FieldInputProps, FieldMetaProps, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { ContentType } from '@candu-ai/content/types';

import { ContentTypeOptions } from './ContentTypeOption';

export const validationSchema = Yup.object().shape({
  contentType: Yup.mixed().oneOf(Object.values(ContentType), 'You must choose a value').required(),
});

interface SelectContentTypeFormProps {
  onSubmit: (payload: object) => void;
  contentType?: ContentType;
  hotspotsOnly?: boolean;
  withTemplate?: boolean;
}

export const SelectContentTypeForm = ({
  onSubmit,
  contentType,
  withTemplate,
}: SelectContentTypeFormProps) => {
  return (
    <Formik
      validateOnMount
      initialValues={{
        contentType:
          contentType && contentType !== ContentType.Inline ? contentType : ContentType.Inline,
      }}
      validationSchema={validationSchema}
      onSubmit={({ ...props }) => onSubmit({ ...props })}
    >
      {({ setFieldValue, isSubmitting, isValid }) => (
        <Form data-cy="create-content-form">
          <Field name="contentType">
            {({
              field,
              meta,
            }: {
              field: FieldInputProps<ContentType>;
              meta: FieldMetaProps<string>;
            }) => (
              <FormField
                label=""
                feedback={meta.touched ? meta.error : ''}
                state={meta.touched && meta.error ? 'danger' : 'none'}
              >
                <ContentTypeOptions
                  noHotspots={!!withTemplate}
                  selectedType={field.value}
                  onSelect={(selected: ContentType) => setFieldValue('contentType', selected)}
                  {...field}
                  {...meta}
                />
              </FormField>
            )}
          </Field>

          <Stack justify="center">
            <Button
              type="submit"
              variant="secondary"
              mt="s"
              loading={isSubmitting}
              disabled={!isValid}
            >
              Next
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
